import {
  FETCH_ORIGINS_REQUEST,
  FETCH_ORIGINS_SUCCESS,
  FETCH_ORIGINS_FAILURE,
  CREATE_ORIGIN_REQUEST,
  CREATE_ORIGIN_SUCCESS,
  CREATE_ORIGIN_FAILURE,
  UPDATE_ORIGIN_REQUEST,
  UPDATE_ORIGIN_SUCCESS,
  UPDATE_ORIGIN_FAILURE,
} from "../actions/origin";

const initialState = {
  origins: [],
  loading: false,
  creating: false,
  updating: false,
  error: null,
};

const originReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORIGINS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ORIGINS_SUCCESS:
      return { ...state, loading: false, origins: action.payload };

    case FETCH_ORIGINS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_ORIGIN_REQUEST:
      return { ...state, creating: true, error: null };

    case CREATE_ORIGIN_SUCCESS: {
      const created = action.payload;
      const exists = state.origins.some((o) => o.id === created.id);

      return {
        ...state,
        creating: false,
        origins: exists
          ? state.origins.map((o) => (o.id === created.id ? created : o))
          : [created, ...state.origins],
      };
    }

    case CREATE_ORIGIN_FAILURE:
      return { ...state, creating: false, error: action.payload };

    case UPDATE_ORIGIN_REQUEST:
      return { ...state, updating: true, error: null };

    case UPDATE_ORIGIN_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        updating: false,
        origins: state.origins.map((o) =>
          o.id === updated.id ? { ...o, ...updated } : o
        ),
      };
    }

    case UPDATE_ORIGIN_FAILURE:
      return { ...state, updating: false, error: action.payload };

    default:
      return state;
  }
};

export default originReducer;
